export type RelativeTimeRangeKey = "1m" | "5m" | "15m" | "1h" | "3h";

export function formatRelativeTick(sec: number): string {
  if (sec === 0) return "now";
  const ago = Math.abs(sec);
  if (ago >= 3600 && ago % 3600 === 0) return `−${ago / 3600}h`;
  if (ago >= 60 && ago % 60 === 0) return `−${ago / 60}m`;
  return `−${ago}s`;
}

export function relativeTimeTicks(
  range: RelativeTimeRangeKey | string,
  windowSec: number,
): { tickvals: number[]; ticktext: string[] } {
  if (range === "1m") {
    return {
      tickvals: [-60, -45, -30, -15, 0],
      ticktext: ["−1m", "−45s", "−30s", "−15s", "now"],
    };
  }

  let stepSec: number;
  switch (range) {
    case "5m":
      stepSec = 60;
      break;
    case "15m":
      stepSec = 180;
      break;
    case "1h":
      stepSec = 900;
      break;
    case "3h":
      stepSec = 1800;
      break;
    default:
      stepSec = 60;
  }

  const tickvals: number[] = [];
  for (let t = -windowSec; t < 0; t += stepSec) {
    tickvals.push(t);
  }
  tickvals.push(0);

  return {
    tickvals,
    ticktext: tickvals.map(formatRelativeTick),
  };
}

/** ECG ribbon range buttons (minutes) → freq chart range keys. */
export function regionalRangeMinutesToKey(minutes: number): RelativeTimeRangeKey {
  switch (minutes) {
    case 1:
      return "1m";
    case 5:
      return "5m";
    case 15:
      return "15m";
    case 60:
      return "1h";
    default:
      return "1m";
  }
}

export function toRelativeSeconds(tsMs: number, anchorMs: number): number {
  return (tsMs - anchorMs) / 1000;
}
